/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { MemoModalMemoFragmentDoc } from './MemoModal.generated';
export type ChatPageHeaderMemoFragment = { id: string, content: string, createdAt: TimeString };

export const ChatPageHeaderMemoFragmentDoc = gql`
    fragment ChatPageHeaderMemo on ChatRoomMemo {
  ...MemoModalMemo
}
    ${MemoModalMemoFragmentDoc}`;